import { memo } from 'react';
import styled from 'styled-components';
import { ComponentRepresentation } from '@ardoq/basic-components';
import { CheckMarkIcon, IconSize } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { TextOverflow } from '@ardoq/popovers';
import { ComponentItemProps } from '../../components/PropTypes';
import { SelectItemContainer } from '../../components/Atoms';
import { NodeExpander } from '../../components/NodeExpander';
import { colors } from '@ardoq/design-tokens';
import { Text } from '@ardoq/typography';
import { HIGHLIGHTED_CLASS_NAME } from '../../consts';

const ComponentContainer = styled(FlexBox)`
  position: relative;
  line-height: 30px;
  height: 30px;
  transition:
    background-color 0.3s,
    opacity 0.3s;
  align-items: center;
`;

const OnHoverText = styled(Text)`
  display: none;
  .${HIGHLIGHTED_CLASS_NAME} & {
    display: block;
  }
  /* prettier-ignore */
  .navigator-container:not(.keyboard-navigation-active) ${ComponentContainer}:hover & {
    display: block;
  }
`;

const ContextSelectorComponentItem = memo(
  ({
    name,
    containerStyle,
    containerClassNames,
    componentRepresentationData,
    iconWrapperClassNames,
    iconWrapperStyle,
    nodeId,
    hasVisibleContent,
    isExpanded,
    isSelected,
    isSelectable,
    isDisabledOption,
    modifierKey,
    actionKey,
    isAllSelected,
    ariaAttributes,
  }: ComponentItemProps) => {
    const showActionHint = !isAllSelected && isSelectable && !isDisabledOption;
    return (
      <SelectItemContainer data-id={nodeId} className={containerClassNames}>
        <ComponentContainer
          style={containerStyle}
          role="treeitem"
          {...ariaAttributes}
        >
          {(isSelected || isAllSelected) && (
            <CheckMarkIcon
              iconSize={IconSize.SMALL}
              style={{ position: 'absolute', left: '0' }}
              color={colors.iconActionActive}
            />
          )}
          <NodeExpander
            hasVisibleContent={hasVisibleContent}
            isExpanded={isExpanded}
            name={name}
          />
          <span className={iconWrapperClassNames} style={iconWrapperStyle}>
            {componentRepresentationData && (
              <ComponentRepresentation
                isImage={componentRepresentationData.isImage}
                value={componentRepresentationData.value}
                icon={componentRepresentationData.icon}
              />
            )}
          </span>
          <TextOverflow
            role="button"
            className="component-name component"
            popoverAcceptsMouse={false}
          >
            {name}
          </TextOverflow>
          {showActionHint && (
            <OnHoverText variant="caption" color="textSubtle">
              {modifierKey}+{actionKey} to {isSelected ? 'remove' : 'add'}
            </OnHoverText>
          )}
        </ComponentContainer>
      </SelectItemContainer>
    );
  }
);

export { ContextSelectorComponentItem };
